import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import ServiceTabsInfo from './serviceTabsInfo'
import ServiceDetailTable from './serviceDetailTable'
import { ArrowLeftOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Button, Spin } from 'antd';   // ✅ 引入 Spin
import { useCustomData } from '../../pages/context/serviceCustomDataProvider';
import { apiGetPage } from '../../request/api'
import EzBottom from '../bottom';

interface ServiceDetailProps {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
    onOpenModal?: (type: 'basic' | 'premium') => void;
    onOpenNote?: (type: any ) => void;
}

const ServiceDetail: React.FC<ServiceDetailProps> = ({ handleViewChange, data, onOpenModal, onOpenNote }) => {
    const serviceId = data.split('|')[0]
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const { getValue } = useCustomData();
    const serviceHomeSubTitle = getValue('serviceHomeSubTitle');
    const renewalDetails = getValue('renewalDetails');
    const back = getValue('back');
    const iwant = getValue('iwant');
    const languageCode = localStorage.getItem('siteLanguage') || 'zh';
    const [serviceInfo, setServiceInfo] = useState<any>(null)
    const [serviceList, setServiceList] = useState<any>(data.split('|')[1])
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        apiGetPage({
            tid: '72D99CCB9A7E439184BF9EF7CABC49BA',
            page: 1,
            size: 100,
            languagecode: languageCode,
            search: 'id:' + serviceId,
        }).then(res => {
            const info = res.data.data.rows[0];
            setServiceInfo(info);

            if (info.id === '89762F6A770A46FE83B7A39C5230E371') {
                setServiceList('B875F07C85DC4E7C9C73B07B4B10778D,3E13A0FC27854CDBACB51608D2203C0A')
            } else {
                setServiceList('839B8C3A610E484EB76FDF329B378FAC,BAA4F165D89B43D399BAF8267FBDEFD5')
            }

            setLoading(false);
        }).catch(() => {
            setLoading(false); // 避免接口异常时卡死在 loading
        })
    }, []);

    const goBack = () => {
        handleViewChange('service-index');
    };

    return (
        <Spin spinning={loading} tip="加载中...">  {/* ✅ 用 Spin 包裹 */}
            <div className='service-add'>
                <div className="detail-back" style={{ color: themeColor, width: "1200px", margin: "0 auto", marginTop: "56px" }}>
                    <ArrowLeftOutlined onClick={goBack} />
                    <div className="detail-back-right" onClick={goBack}>
                        {back}
                    </div>
                </div>
                <div className='service-h1' style={{ marginTop: "40px" }}>{serviceHomeSubTitle}</div>
                <div className="service-detail-tab-h2" style={{ color: themeColor }}>
                    <div>{serviceInfo?.commodityName}</div>
                    <div>
                        <InfoCircleOutlined
                            onClick={() => {
                                const List = {
                                    commodityType: serviceInfo.commodityType + "-" + serviceInfo.commodityName,
                                    commodityRemark: serviceInfo.commodityRemark
                                }
                                onOpenNote?.(List);
                            }}
                            style={{ fontSize: '22px' }}
                        />
                    </div>
                </div>
                <ServiceTabsInfo id={serviceId} onOpenModal={onOpenModal} onOpenNote={onOpenNote} />
                <div className='service-button-div'>
                    <Button className='service-button'
                        style={{ boxShadow: `0 2px 4px 0 ` + themeColor }}
                        type="primary"
                        onClick={() => {
                            onOpenModal?.(serviceInfo);
                        }}
                    >
                        {iwant}
                    </Button>
                </div>
                <div className='service-h1'>{serviceInfo?.commodityName}{renewalDetails}</div>
                <ServiceDetailTable handleViewChange={handleViewChange} servicesInfo={serviceList} onOpenModal={onOpenModal} onOpenNote={onOpenNote} />
                <EzBottom />
            </div>
        </Spin>
    )
};

export default ServiceDetail;
